import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import PresaleDetail from 'components/sales/leadDetails/presaleDetail/presaleDetail';
import PostsaleDetail from 'components/sales/leadDetails/postsaleDetail/postsaleLeadType';
import LeadDetail from 'components/sales/leadDetails/createLeadDetail/leadDetail';
import localization from 'assets/localization/localization';
import Notfound from 'pages/notfound';
import { BaseUrl } from '../../../contexts/baseUrl/baseUrl';
import {Button} from "react-bootstrap";
import ModalPop from 'components/sales/modal/modal';
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import "./viewDetail.css";
import Images from 'assets/images/imageData';
import { Link, NavLink } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

const ViewSitedetails = ({
  viewDetails,
  getDetails,
  giveRating,
  getRating,
  match,
  changeSiteState,
  getSiteState,
  siteEnableDisable = {},
  changeSiteStateAsExpired,
  changeSiteStateLegalEnable,
  siteDismantle,
}) => {
  const [details, setDetails] = useState(null);
  const [leadId, setleadId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isEnable, setEnable] = useState(false);
  const [isSitePmPending, setSitePmPending] = useState(false);
  const [siteId, setSiteId] = useState("");
  const [showPop, setShowPop] = useState(false);
  const [remark, setRemarks] = useState("");
  const [showExp, setShowExpPop] = useState(false);
  const [disputePop, setDisputePop] = useState(false);
  const statusCodes = [21,22,23,24,25,26,27];
  const [roleId, setRoleId] = useState('');
  const [disputeEnablePop, setDisputeEnablePop] = useState(false);
  const [commercialType, setCommercialType] = useState(null);
  const [isModal, setIsModal] = useState(false);
  const [status, setStatus] = useState('');
  const [remarkData, setRemarkData] = useState('');
  const [responseData, setResponseData] = useState(null);
  const [isStatusModal, setIsStatusModal] = useState(null);
  const [isResStatusModal, setIsResStatusModal] = useState(true);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(true);
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
        setRoleId(roles);
      })();
      setIsLoading(false);
    }, 0);
  }, []);

  useEffect(() => {
    (async () => {
      const lead = localStorage.getItem('viewDetail');
      //setSiteId("")
      if (lead !== 'undefined' && lead && leadId) {
        const leadTypeId = await JSON.parse(lead)?.[0].lead_type_id;

        const requestData = {
          lead_id: leadId,
          lead_type: leadTypeId,
          site_id:siteId
        };
        const res = await getDetails(requestData);
        setIsLoading(false);
        if (res === null || res === '') {
          setIsRender(true);
        }
      }
    })();
  }, [getDetails, leadId]);

  useEffect( () => {
    // if (viewDetails && viewDetails?.site) {
    //   console.log(viewDetails);
      (async () => {setIsLoading(true);
        await getSiteState(match.params.id)
      })();
    // }
  }, [match.params.id])

  useEffect(() => {
    if (viewDetails) {
      setDetails(viewDetails);
    }
    setleadId(match.params.leadId);
    setSiteId(match.params.id);
  }, [viewDetails, match.params.leadId]);

  useEffect(() => {
    console.log('Contract Type ' + details?.postsale_data?.commercial?.commercial_type_id);
    setCommercialType(parseInt(details?.postsale_data?.commercial?.commercial_type_id));
  },[details]);

  const showRemarkPop = () => {
    setShowPop(true)
  }

  const showExpiredPopup = () => {
    setShowExpPop(true)
  }

  const showDisputePopup = () => {
    setDisputePop(true)
  }

  const showDisputeEnablePopup = () => {
    setDisputeEnablePop(true)
  }

  const headerBtns = () => {

    setEnable(false);
    if(Object.keys(siteEnableDisable).length > 0 ){
      if(siteEnableDisable.state === "DISABLE"){
        if(siteEnableDisable.status === "REJECTED"){
          setSitePmPending(false);
        }else if(siteEnableDisable.status === "PENDING"){
          setSitePmPending(true);
        }else {
          setSitePmPending(false);
          setEnable(true);
        }
      }

      if(siteEnableDisable.state === "ENABLE"){
        if(siteEnableDisable.status === "REJECTED"){
          setSitePmPending(false);
          setEnable(true);
        }else if(siteEnableDisable.status === "PENDING"){
          setSitePmPending(true);
          setEnable(true);
        }else {
          setSitePmPending(false);
          setEnable(false);
        }
      }
    }

 

    
    const isLertButtonDisabled = Number(details?.show_lert_button) !== 1;

    return (
        <>
            {(roleId == 17 || roleId == 56) && details && details?.site && details?.site['status'] && (details?.site['status'] === 2 || details?.site['status'] === 3) &&
            <>
            <span
              data-tip={isLertButtonDisabled ? '' : undefined}
              data-for={isLertButtonDisabled ? 'lert-disabled-tip' : undefined}
              style={{ display: 'inline-block' }}
            >
            <Button
                onClick={() => onLERTFirst(true)}
                className="btn btn-warning"
                disabled={isLertButtonDisabled}
              >
                {" "}
                LERT
              </Button>
            </span>
            {isLertButtonDisabled && (
              <ReactTooltip id="lert-disabled-tip" place="top" type="info">
                {details?.lert_button_message ||
                  'Mandatory leadership visits are pending. Site cannot be moved to LERT.'}
              </ReactTooltip>
            )}
            </>
            }
           {((roleId == 17  || roleId == 56) && details && details?.site && details?.site['status'] && (details?.site['status'] === 32 || details?.site['status'] === 33 )) ?
            <Button
                onClick={() => onLERTLIVEFirst(true)}
                className="btn btn-theme"
              >
                {" "}
                LERT To Live
              </Button>
              : null
              }
          {(roleId == 15 || roleId == 14) && details && details?.site && details?.site['status'] && (details?.site['status'] === 2 || details?.site['status'] === 16 ) && <Button
              className="btn btn-primary d-md-inline-block "
              onClick={() => {
                showRemarkPop();
              }}
              disabled={isSitePmPending}
          >
            {isEnable ? 'Enable' : 'Disable'}
          </Button>
          }
          {commercialType == 5 && roleId != '' && (roleId == 17 || roleId == 16) && details && details?.site && details?.site['status'] && (details?.site['status'] === 2) &&
          <>
            <Button className="btn btn-primary d-md-inline-block " onClick={() => {showExpiredPopup();}}>
             Contract Expired
            </Button>
          </>  
          }
          {commercialType == 7 && roleId != '' && roleId == 17 && details && details?.site && details?.site['status'] && (details?.site['status'] === 2) &&
          <>
            <Button className="btn btn-primary d-md-inline-block " onClick={() => {showDisputePopup();}}>
             Leagl Dispute
            </Button>
          </>  
          }
          {roleId != '' && (roleId == 17 || roleId == 16) && details && details?.site && details?.site['status'] && (details?.site['status'] === 22) &&
            <>
              <Button className="btn btn-primary d-md-inline-block " onClick={() => {showDisputeEnablePopup();}}>
              Remove Legal Dispute
              </Button>
            </>  
          }
          {details && details?.current_status && statusCodes.includes(details?.current_status.status) && 
            <>
              <span className='vfx-org'>{details?.current_status.status_name}</span>
            </> 
          }
        </>
    );
  };

  
  const onLERTLIVEFirst = async (e) => {
    setIsLoading(true);
    if(e){
      setStatus(34);
      setIsModal(true);
    }
    setIsLoading(false);
  }

  const onLERTLive = async (e) => {
    setIsLoading(true);
    if(e){
      const res = await siteDismantle(match.params.id,34,remarkData,'LERT To Live');
      var msg = '';
      var resstatus = true;
      if(res.data.message){
        msg = res.data.message;
        resstatus = res.data.status;
        if(res.data.response.data){
          setResponseData(res.data.response.data);
        }
      }else{
        msg = 'Success!';
        resstatus = true;

      }
      console.log(resstatus+"====="+msg);
      setIsStatusModal(msg);
      setIsResStatusModal(resstatus);
      setIsStatusSuccess(true);
      // await getSiteStage(siteId);
     
      
    }
    setIsLoading(false);
    
  };

  const onLERTFirst = async (e) => {
    setIsLoading(true);
    if(e){
      setStatus(31);
      setIsModal(true);
    }
    setIsLoading(false);
  }

  const onLERT = async (e) => {
    setIsLoading(true);
    if(e){
      const res = await siteDismantle(match.params.id,31,remarkData,'LERT');
      var msg = '';
      var resstatus = true;
      if(res.data.message){
        msg = res.data.message;
        resstatus = res.data.status;
        if(res.data.response.data){
          setResponseData(res.data.response.data);
        }
      }else{
        msg = 'Success!';
        resstatus = true;

      }
      console.log(resstatus+"====="+msg);
      setIsStatusModal(msg);
      setIsResStatusModal(resstatus);
      setIsStatusSuccess(true);
      // await getSiteStage(siteId);
     
      
    }
    setIsLoading(false);
    
  };

  const handleModalHide = () => setShowPop(false);
  const handleModalHideExp = () => setShowExpPop(false);
  const handleModalHideDispue = () => setDisputePop(false);
  const handleModalHideDispueEnable = () => setDisputeEnablePop(false);

  const handleDisableSite = async () => {
    let value = isEnable ? 'enable' : 'disable';

    if(remark === ""){
      alert("Remark is required")
      return false
    }

    let data = {
      'state' : value,
      'site_id': details?.site['id'],
      'remark': remark
    };

    const res = await changeSiteState(data)
    if(res){
      setShowPop(false)
      window.location.reload(false);
    }
  }

  const handleDisableSiteExp = async () => {
    if(remark === ""){
      alert("Remark is required")
      return false;
    }

    let data = {
      'status' : 21,
      'site_id': details?.site['id'],
      'remark': remark
    };
    setIsLoading(true);
    const res = await changeSiteStateAsExpired(data);
    if(res){
      setIsLoading(false);
      setShowExpPop(false);
      window.location.reload(false);
    }
    setIsLoading(false);
  }

  const handleLegalDispute = async () => {
    if(remark === ""){
      alert("Remark is required")
      return false;
    }

    let data = {
      'status' : 22,
      'site_id': details?.site['id'],
      'remark': remark
    };
    setIsLoading(true);
    const res = await changeSiteStateAsExpired(data);
    if(res){
      setIsLoading(false);
      setDisputePop(false);
      window.location.reload(false);
    }
    setIsLoading(false);
  }

  const handleLegalDisputeEnable = async () => { 
    if(remark === ""){
      alert("Remark is required")
      return false;
    }

    let data = {
      'status' : 25,
      'site_id': details?.site['id'],
      'remark': remark
    };
    setIsLoading(true);
    const res = await changeSiteStateLegalEnable(data);
    if(res){
      setIsLoading(false);
      setDisputeEnablePop(false);
      window.location.reload(false);
    }
    setIsLoading(false);
  }

  return isRender ? (
    <Notfound />
  ) : (
    <Layout
      title={localization.BacktoList}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/sites-listing`}
      Buttons={headerBtns}
    >
      <ModalPop
          title={"Site Disable Remark"}
          show={showPop}
          handleModalHide={handleModalHide}
      >
        <div className="col-12">
          <ConstantInput
              label={localization.remark}
              type="text"
              value={remark}
              handleChange={(val) => {
                setRemarks(val);
              }}
              required
              isStarRequired={true}
          />
        </div>
        <div className="text-center">
          <Button
              onClick={handleDisableSite}
              className="btn btn-primary mb-4"
          >
            {localization.submit}
          </Button>
        </div>
      </ModalPop>

      <ModalPop
          title={"Mark Expired"}
          show={showExp}
          handleModalHide={handleModalHideExp}
      >
        <div className="col-12">
          <ConstantInput
              label={localization.remark}
              type="text"
              value={remark}
              handleChange={(val) => {
                setRemarks(val);
              }}
              required
              isStarRequired={true}
          />
        </div>
        <div className="text-center">
          <Button
              onClick={handleDisableSiteExp}
              className="btn btn-primary mb-4"
          >
            {localization.submit}
          </Button>
        </div>
      </ModalPop>

      <ModalPop
          title={"Legal Dispute"}
          show={disputePop}
          handleModalHide={handleModalHideDispue}
      >
        <div className="col-12">
          <ConstantInput
              label={localization.remark}
              type="text"
              value={remark}
              handleChange={(val) => {
                setRemarks(val);
              }}
              required
              isStarRequired={true}
          />
        </div>
        <div className="text-center">
          <Button
              onClick={handleLegalDispute}
              className="btn btn-primary mb-4"
          >
            {localization.submit}
          </Button>
        </div>
      </ModalPop>

      <ModalPop
          title={"Legal Dispute Enable"}
          show={disputeEnablePop}
          handleModalHide={handleModalHideDispueEnable}
      >
        <div className="col-12">
          <ConstantInput
              label={localization.remark}
              type="text"
              value={remark}
              handleChange={(val) => {
                setRemarks(val);
              }}
              required
              isStarRequired={true}
          />
        </div>
        <div className="text-center">
          <Button
              onClick={handleLegalDisputeEnable}
              className="btn btn-primary mb-4"
          >
            {localization.submit}
          </Button>
        </div>
      </ModalPop>

      {details?.lead_data && Object.keys(details.lead_data).length > 0 && (
        <>
        <LeadDetail
          details={details}
          pageTitle={localization.viewDetails}
          giveRating={giveRating}
          getRating={getRating}
          site_id={match.params.leadId}
        />
        </>
      )}

      {/*{details?.presale_data &&*/}
      {/*  Object.keys(details.presale_data).length > 0 && (*/}
      {/*    <PresaleDetail details={details.presale_data} />*/}
      {/*  )}*/}

      {details?.postsale_data &&
        Object.keys(details.postsale_data).length > 0 && (
          <PostsaleDetail
            details={details.postsale_data}
            renewContracts = {details}
          />
        )}

<ModalPop
        title={localization.changeStatus}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
        {(status === 31) ?
          <h5>Enter remark to LERT this site</h5>
          :
          <h5>Enter remark to Live this site</h5>
        }
          <ConstantInput
                label='Remark'
                type="text"
                value={remarkData}
                handleChange={(val) =>
                  setRemarkData(val)
                }
                required
              />

      {(status === 31) &&
              <Button
              className="btn btn-warning mb-4"
              onClick={() => onLERT(31)}
            >
              {localization.continue} <img src={Images?.ArrowRight} alt="" />
            </Button>
              }
       {(status === 34) &&
              <Button
              className="btn btn-theme mb-4"
              onClick={() => onLERTLive(34)}
            >
              {localization.continue} <img src={Images?.ArrowRight} alt="" />
            </Button>
              }
         
          
        </div>
      </ModalPop>
      <ModalPop
        title='Status Change'
        show={isStatusSuccess}
      >
        <div className="text-center">
          {isResStatusModal ? 
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            :
            <div className="danger">
              <img src={Images?.alert} alt="" />
            </div>
           }
          <h5>{isStatusModal}</h5>
          
          <Link
                to={`${baseUrl}/brand-activation/sites-listing`}
                className="btn btn-theme mb-4"
              >
            {localization.goBack}
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

ViewSitedetails.propTypes = {
  viewDetails: PropTypes.any,
  getDetails: PropTypes.func,
  match: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default ViewSitedetails;
